/**
 * Hidden field bots tend to fill in. Render it inside any form whose handler
 * rejects a non-empty `HONEYPOT_FIELD`; it stops naive form-fillers only and is
 * never a substitute for an edge rate limit.
 *
 * Offscreen rather than `display: none` or `hidden` — bots skip fields that never
 * render.
 *
 * Styled inline rather than with styled-components on purpose: this app ships no
 * server-rendered styled-components CSS (there is no `ServerStyleSheet` in
 * `entry.server.tsx`), so a class-based rule would leave the input **visible** to
 * real users until hydration. An inline style is hidden in the SSR HTML itself.
 */

import type { CSSProperties } from 'react';
import { HONEYPOT_FIELD } from '~/common/constants/gatedRoutes';

const HIDDEN: CSSProperties = {
  position: 'absolute',
  left: '-9999px',
  width: '1px',
  height: '1px',
  opacity: 0,
  pointerEvents: 'none',
};

export const HoneypotField = () => (
  <input
    type="text"
    name={HONEYPOT_FIELD}
    tabIndex={-1}
    autoComplete="off"
    aria-hidden="true"
    style={HIDDEN}
  />
);
